function o(o,t){return o=Math.ceil(o),t=Math.floor(t),Math.floor(Math.random()*(t-o+1)+o)}export{o as getRandomNumber};
